import { ENV } from '../../config/runtimeEnv';
import axios from 'axios';
import {
  PatientAnalysis,
  PatientAnalysisStatusResponse,
  PractitionerReview,
} from '../../types/healthcare/PatientAnalysisTypes';
import type { UserUuid } from '../../types/identity';
import { http } from '../../lib/http/client';

const BASE = ENV.VITE_HEALTHCARE_SERVER;

export const fetchPatientAnalysis = async (patientId: UserUuid): Promise<PatientAnalysis | null> => {
  try {
    const res = await http.get(`${BASE}/patients/${patientId}/analysis`);
    return res.data.data;
  } catch (err: unknown) {
    if (axios.isAxiosError(err) && err.response?.status === 404) return null;
    throw err;
  }
};

export const triggerPatientAnalysis = async (patientId: UserUuid, company: string): Promise<void> => {
  await http.post(
    `${BASE}/patients/${patientId}/analysis/generate`,
    { company },
  );
};

export const fetchPatientAnalysisStatus = async (
  patientId: UserUuid,
): Promise<PatientAnalysisStatusResponse> => {
  const res = await http.get(`${BASE}/patients/${patientId}/analysis/status`);
  return res.data;
};

export const getPatientAnalysisById = async (id: number): Promise<PatientAnalysis> => {
  const res = await http.get(`${BASE}/practitioner/patient-analyses/${id}`);
  return res.data.data;
};

export const reviewAndAdvanceAnalysis = async (planId: number): Promise<void> => {
  await http.post(
    `${BASE}/practitioner/patient-treatment-plans/${planId}/review-comprehensive-analysis`,
    {},
  );
};

export const savePractitionerReview = async (
  planId: number,
  review: Partial<PractitionerReview>,
): Promise<void> => {
  await http.put(
    `${BASE}/practitioner/patient-treatment-plans/${planId}/comprehensive-analysis/practitioner-review`,
    review,
  );
};

export const signOffAnalysis = async (
  id: number,
  data: {
    review_status: 'approved' | 'approved_with_amendments' | 'rejected';
    practitioner_amendments?: string;
  },
): Promise<PatientAnalysis> => {
  const res = await http.post(
    `${BASE}/practitioner/patient-analyses/${id}/sign-off`,
    data,
  );
  return res.data.data;
};
